import React from 'react'
import "../CSS/contact.css"
import NavBar from '../Components/NavBar'
import { PRANAV_PHOTO, RAJA_PHOTO, SAPNA_PHOTO, TOJO_PHOTO } from '../Constants'

let Contact = () => {
    return (
        <>
            <NavBar></NavBar>
            <h1 className = "roboto-condensed-700" style = {{marginTop : "2%"}}>Contact Us</h1>
            <div className = "contact">
                <div className = "contact-member">
                    <img src = {RAJA_PHOTO} className = "contact-photo"></img>
                    <h3 className = "roboto-condensed-700" >Prof. Raja Muthalagu</h3>
                    <p className = "roboto-condensed-300">raja.m@dubai.bits-pilani.ac.in</p>
                </div>
                <div className = "contact-member">
                    <img src = {PRANAV_PHOTO}  className = "contact-photo" ></img>
                    <h3 className = "roboto-condensed-700" >Prof. Pranav M Pawar</h3>
                    <p className = "roboto-condensed-300">pranav@dubai.bits-pilani.ac.in </p>
                </div>
                <div className = "contact-member">
                    <img src = {TOJO_PHOTO}  className = "contact-photo"></img>
                    <h3 className = "roboto-condensed-700" >Prof.Tojo Mathew</h3>
                    <p className = "roboto-condensed-300">tojomathew@dubai.bits-pilani.ac.in </p>
                </div>
                <div className = "contact-member">
                    <img src = {SAPNA_PHOTO}  className = "contact-photo"></img>
                    <h3 className = "roboto-condensed-700" >Prof. Sapna Sadhwani </h3>
                    <p className = "roboto-condensed-300">sapna@dubai.bits-pilani.ac.in</p>
                </div>

                
            </div>
            <h4 className = "roboto-condensed-500" style = {{textAlign: "center"}}>Contact Email: cins2025@dubai.bits-pilani.ac.in</h4>
        </>
    )
}


export default Contact
